import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { User } from '../models/user';
import { SessionStorageService } from './session-storage.service';
//import { API_URL } from "./../../modules/shared/constants/urls";
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
//import { MatDialog } from "@angular/material/dialog";

const USER = 'user';
const CUSTOMER_SELECTIONS = 'selectedCustomer';
const APPROVAL = 'approval';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private API_URL = environment.API_URL;
  private currentUserSubject: BehaviorSubject<User | null>;
  private currentNotificationSubject: BehaviorSubject<number | null>;

  public currentUser: Observable<User | null>;
  public currentNotification: Observable<number | null>;

  constructor(
    private http: HttpClient,
    private localService: SessionStorageService,
    private sessionService: SessionStorageService,
    private route: Router, //public dialog: MatDialog,
    private keycloakService:KeycloakService
  ) {
    this.currentUserSubject = new BehaviorSubject<User | null>(null);
    this.currentNotificationSubject = new BehaviorSubject<number | null>(null);
    this.currentUser = this.currentUserSubject.asObservable();
    this.currentNotification = this.currentNotificationSubject.asObservable();
  }

  login(userid: string, password: string) {
    // return this.http.post(this.API_URL + '/authenticate', {
    //   userid,
    //   password,
    // });
    return this.http.get(`../../../assets/mock.json`);
  }

  refreshToken(token) {
    return this.http.post(this.API_URL + '/api/v1/refreshtoken', {
      refreshToken: this.keycloakService.getKeycloakInstance().refreshToken,
      accessToken: this.keycloakService.getKeycloakInstance().token,
    });
  }

  setCurrentUser(user: User, store_locally = false) {
    if (store_locally) {
      this.localService.createItem<User>(USER, user);
    } else {
      this.sessionService.createItem<User>(USER, user);
    }
    this.currentUserSubject.next(user);
  }
  setCurrentNotification(number: any) {
    this.currentNotificationSubject.next(number);
  }
  getCurrentNotification() {
    return this.currentNotificationSubject.value;
  }
  getCurrentUser() {
    return this.keycloakService.getKeycloakInstance().token;
  }

  loadLocaluser() {
    let user =
      this.sessionService.getItem<User>(USER) ||
      this.localService.getItem<User>(USER);
    this.currentUserSubject.next(user);
  }

  getuserData() {
    return USER;
  }
  logout() {
    this.currentUserSubject.next(null);
    this.sessionService.deleteItem(USER);
    this.localService.deleteItem(USER);
    this.localService.deleteItem(APPROVAL);
    this.localService.deleteItem(CUSTOMER_SELECTIONS);
    localStorage.clear();
    this.route.navigate(['/']);
  }
  forgotPassword(email) {
    return this.http.post(`${this.API_URL}/api/v1/forgot-password`, email);
  }
  ResetPassword(reset_password_token: string, password: string) {
    return this.http.post(`${this.API_URL}/api/v1/reset-password`, {
      reset_password_token,
      password,
    });
  }
  changePassword(email: string, password: string) {
    return this.http.post(`${this.API_URL}/api/v1/change-password`, {
      password,
      email,
    });
  }
  ValidPasswordToken(token) {
    return this.http.post(`${this.API_URL}/api/v1/validate-token`, token);
  }
  getUserDetails(qParam: any) {
    return this.http.get(`${this.API_URL}/api/v1/getUserDetails`, {
      params: {
        usert_token: qParam.user_token || '',
      },
    });
  }
  public sendRequest(formData: any) {
    return this.http.post(
      `${this.API_URL}/api/notification/sendMail`,
      formData
    );
  }
  public getMail() {
    return this.http.get(`${this.API_URL}/api/notification/getMail`);
  }
}
